import axios from 'axios'

export default {
  getUser ( timesheetId, callback, fallback ) {
    axios.get('/timesheets/' + timesheetId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/timesheets', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( timesheetId, data, callback, fallback ) {
    axios.post( '/timesheets/' + timesheetId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( timesheetId, callback, fallback ) {
    axios.delete( '/timesheets/' + timesheetId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getJobsWithTimesheets ( params, callback, fallback ) {
    axios.get( '/timesheets', { params } )
      .then(resp => {
        if ( typeof callback == 'function' ) {
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
        }
      })
      .catch(error => {
        if ( typeof fallback == 'function' ) {
          if(typeof(fallback) != 'undefined') fallback( error );
        }
      })
  },
  printTimesheets ( params, callback, fallback ) {
    axios.get('/timesheets/csv', {
      responseType: 'blob', // important
      params
    }).then(resp => {
      if ( typeof callback == 'function' )
        callback( resp );
    }).catch(error => {
      if ( typeof fallback == 'function' )
        fallback(error);
    });
  }
}
